"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _logger = require("@insided/shared/services/logger");

var _phrase = _interopRequireWildcard(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _TopicFavorite = _interopRequireDefault(require("@insided/deprecated-preact-components/topic-list-view/TopicFavorite"));

var _ReportContentModal = _interopRequireDefault(require("../../Post/ReportContentModal"));

var _AlertComponent = _interopRequireDefault(require("@insided/shared/uikit/AlertComponent"));

var _globals = require("@insided/shared/utils/globals");

var _axios = _interopRequireDefault(require("axios"));

var _contentType = require("@insided/shared/utils/contentType");

var _classnames = _interopRequireDefault(require("classnames"));

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

var _csrfToken = require("@insided/deprecated-preact-components/utils/csrfToken");

var _OnDemandTranslations = require("@insided/shared/modules/HubAI/OnDemandTranslations");

var _PostActionsDropdown = _interopRequireDefault(require("../../Post/PostActionsDropdown"));

var _utils = require("../../utils");

var _ExtraMenu = _interopRequireDefault(require("@insided/deprecated-preact-components/content/ExtraMenu"));

var _MarkAsSpamModal = _interopRequireDefault(require("../../Post/MarkAsSpamModal"));

var _TrashModal = _interopRequireDefault(require("../../Post/TrashModal"));

var _topicService = require("../../services/topicService");

var _UserContext = require("@insided/shared/services/UserContext");

var _topicService2 = require("@insided/shared/services/topicService");

var _common = require("@insided/shared/utils/common");

var _TopLikedBy = _interopRequireDefault(require("../../TopLikedBy"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'post-actions';
exports.cssAnchorName = cssAnchorName;

var TopicActions = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TopicActions, _Component);

  var _super = _createSuper(TopicActions);

  function TopicActions(props) {
    var _this$props$reply$hig, _this$props, _this$props$reply;

    var _this;

    (0, _classCallCheck2.default)(this, TopicActions);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isShareMenuOpen: false,
      isLiked: _this.props.isLiked,
      isBestAnswerClicked: false,
      isReplyHighlighted: (_this$props$reply$hig = (_this$props = _this.props) === null || _this$props === void 0 ? void 0 : (_this$props$reply = _this$props.reply) === null || _this$props$reply === void 0 ? void 0 : _this$props$reply.highlighted) !== null && _this$props$reply$hig !== void 0 ? _this$props$reply$hig : false,
      showReportContentModal: false,
      showMarkAsSpamModal: false,
      showTrashModal: false,
      alert: undefined
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "likePending", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "shareTimeout", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "showReportContentModal", function (show) {
      _this.setState({
        showReportContentModal: show
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "showMarkAsSpamModal", function (show) {
      _this.setState({
        showMarkAsSpamModal: show
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "showTrashModal", function (show) {
      _this.setState({
        showTrashModal: show
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleShowAlert", function (type, message) {
      _this.setState({
        alert: {
          type: type,
          message: typeof message === 'string' ? (0, _preact.h)(_phrase.default, {
            p: message
          }) : message !== null && message !== void 0 ? message : (0, _preact.h)(_phrase.default, {
            p: "topic_view.reported_content_modal.error"
          })
        }
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onLikeClick", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(e) {
        var newIsLiked;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                e.preventDefault();

                if (!_this.likePending) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                _this.likePending = true;
                newIsLiked = !_this.state.isLiked;

                _this.updateLikeState(newIsLiked);

                _context.prev = 6;
                _context.next = 9;
                return _this.makeLikeRequest(newIsLiked);

              case 9:
                _context.next = 15;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](6);

                _this.updateLikeState(!newIsLiked);

                throw _context.t0;

              case 15:
                _context.prev = 15;
                _this.likePending = false;
                return _context.finish(15);

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[6, 11, 15, 18]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onQuoteClick", function (e) {
      e.preventDefault();
      (0, _globals.publish)('quote', {
        username: _this.props.quoteUsername,
        content: _this.props.quoteText
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onShareEnter", function () {
      if (_this.shareTimeout) clearTimeout(_this.shareTimeout);

      _this.setState({
        isShareMenuOpen: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onShareLeave", function () {
      _this.shareTimeout = setTimeout(function () {
        return _this.setState({
          isShareMenuOpen: false
        });
      }, 300);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleBestAnswerClick", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(e) {
        var isBestAnswerClicked, isBestAnswer, _this$props2, contentType, privateReplyId, postId;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                isBestAnswerClicked = _this.state.isBestAnswerClicked;
                isBestAnswer = _this.props.isBestAnswer;
                e.preventDefault();

                if (!isBestAnswerClicked) {
                  _context2.next = 6;
                  break;
                }

                e.stopPropagation();
                return _context2.abrupt("return");

              case 6:
                _this$props2 = _this.props, contentType = _this$props2.contentType, privateReplyId = _this$props2.privateReplyId, postId = _this$props2.postId;
                _context2.prev = 7;

                if (!isBestAnswer) {
                  _context2.next = 13;
                  break;
                }

                _context2.next = 11;
                return _axios.default.delete("/community/api/".concat((0, _contentType.getConsistentContentType)(contentType), "s/replies/").concat(privateReplyId, "/answer"), {
                  data: {
                    csrfToken: (0, _csrfToken.csrfToken)()
                  }
                });

              case 11:
                _context2.next = 15;
                break;

              case 13:
                _context2.next = 15;
                return _axios.default.post("/community/api/".concat((0, _contentType.getConsistentContentType)(contentType), "s/replies/").concat(privateReplyId, "/answer"));

              case 15:
                _this.setState({
                  isBestAnswerClicked: true
                });

                _this.handleShowAlert('success', isBestAnswer ? (0, _preact.h)(_phrase.default, {
                  p: "frontend_moderation.reply_unmarked_as_best_answer"
                }) : (0, _preact.h)(_phrase.default, {
                  p: "frontend_moderation.reply_marked_as_best_answer"
                }));

                window.location.assign("".concat(window.location.pathname, "/?postid=").concat(postId, "#post").concat(postId));
                _context2.next = 24;
                break;

              case 20:
                _context2.prev = 20;
                _context2.t0 = _context2["catch"](7);

                _logger.logger.error(_context2.t0, {
                  component: 'TopicActions',
                  action: 'toggleBestAnswer'
                });

                _this.handleShowAlert('error', isBestAnswer ? (0, _preact.h)(_phrase.default, {
                  p: "frontend_moderation.error_unmarking_best_answer"
                }) : (0, _preact.h)(_phrase.default, {
                  p: "frontend_moderation.error_marking_best_answer"
                }));

              case 24:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[7, 20]]);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onHighlightReply", function () {
      _this.setState(function (prevState) {
        return {
          isReplyHighlighted: !prevState.isReplyHighlighted
        };
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getMenuOptions", function () {
      var _this$props$showPostA;

      var _this$props3 = _this.props,
          contentType = _this$props3.contentType,
          postId = _this$props3.postId,
          showEdit = _this$props3.showEdit,
          onEditClick = _this$props3.onEditClick,
          isPostTranslated = _this$props3.isPostTranslated,
          onDisplayOriginal = _this$props3.onDisplayOriginal,
          showReportContent = _this$props3.showReportContent,
          privateReplyId = _this$props3.privateReplyId,
          privateId = _this$props3.privateId,
          isClosed = _this$props3.isClosed;
      var isReplyHighlighted = _this.state.isReplyHighlighted;
      var showPostActions = (_this$props$showPostA = _this.props.showPostActions) !== null && _this$props$showPostA !== void 0 ? _this$props$showPostA : false;
      var params = {
        postId: postId,
        privateReplyId: privateReplyId,
        contentType: contentType,
        onEditClick: onEditClick,
        isPostTranslated: isPostTranslated,
        onDisplayOriginal: onDisplayOriginal,
        showReportContentModal: _this.showReportContentModal,
        showMarkAsSpamModal: _this.showMarkAsSpamModal,
        showTrashModal: _this.showTrashModal,
        isReplyHighlighted: isReplyHighlighted,
        onHighlightReply: _this.onHighlightReply,
        onShowAlert: _this.handleShowAlert,
        privateId: privateId,
        isClosed: isClosed
      };
      return showPostActions ? (0, _preact.h)(_PostActionsDropdown.default, {
        menuOptions: (0, _utils.extraMenuItems)(params)
      }) : (0, _preact.h)(_ExtraMenu.default, {
        postId: postId,
        showEdit: showEdit,
        showReport: showReportContent,
        onEditClick: /*#__PURE__*/function () {
          var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(e) {
            return _regenerator.default.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.next = 2;
                    return (0, _utils.onEdit)(e, onEditClick, isPostTranslated, onDisplayOriginal);

                  case 2:
                    return _context3.abrupt("return", _context3.sent);

                  case 3:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          }));

          return function (_x3) {
            return _ref3.apply(this, arguments);
          };
        }(),
        onReportClick: function onReportClick(e) {
          return (0, _utils.onReport)(e, _this.showReportContentModal);
        }
      });
    });
    _this.onLikeClick = _this.onLikeClick.bind((0, _assertThisInitialized2.default)(_this));
    _this.onQuoteClick = _this.onQuoteClick.bind((0, _assertThisInitialized2.default)(_this));
    _this.onShareEnter = _this.onShareEnter.bind((0, _assertThisInitialized2.default)(_this));
    _this.onShareLeave = _this.onShareLeave.bind((0, _assertThisInitialized2.default)(_this));
    _this.showReportContentModal = _this.showReportContentModal.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleShowAlert = _this.handleShowAlert.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(TopicActions, [{
    key: "updateLikeState",
    value: function updateLikeState(isLiked) {
      this.setState({
        isLiked: isLiked
      });

      if (this.props.onLikeClick) {
        this.props.onLikeClick();
        return;
      } // trigger legacy user like list to update


      window.app.events.commands.execute("post:like:".concat(this.props.postId), {
        currentUserHasLiked: isLiked
      });
    }
  }, {
    key: "makeLikeRequest",
    value: function () {
      var _makeLikeRequest = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(newLikeState) {
        var _this$props4, privateReplyId, contentType, privateId, userId, consistentContentType;

        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this$props4 = this.props, privateReplyId = _this$props4.privateReplyId, contentType = _this$props4.contentType, privateId = _this$props4.privateId;
                userId = (0, _insidedDataStorage.getInsidedData)('user').userid;
                consistentContentType = (0, _contentType.getConsistentContentType)(contentType);

                if (!(privateReplyId && contentType)) {
                  _context4.next = 14;
                  break;
                }

                if (!newLikeState) {
                  _context4.next = 10;
                  break;
                }

                _context4.next = 7;
                return (0, _topicService.likeReply)(consistentContentType, privateReplyId, userId);

              case 7:
                _context4.t0 = _context4.sent;
                _context4.next = 13;
                break;

              case 10:
                _context4.next = 12;
                return (0, _topicService.unlikeReply)(consistentContentType, privateReplyId, userId);

              case 12:
                _context4.t0 = _context4.sent;

              case 13:
                return _context4.abrupt("return", _context4.t0);

              case 14:
                if (privateId) {
                  _context4.next = 16;
                  break;
                }

                throw new Error('privateId is required for topic like/unlike');

              case 16:
                if (!newLikeState) {
                  _context4.next = 22;
                  break;
                }

                _context4.next = 19;
                return (0, _topicService.likeTopic)(consistentContentType, privateId, userId);

              case 19:
                _context4.t1 = _context4.sent;
                _context4.next = 25;
                break;

              case 22:
                _context4.next = 24;
                return (0, _topicService.unlikeTopic)(consistentContentType, privateId, userId);

              case 24:
                _context4.t1 = _context4.sent;

              case 25:
                return _context4.abrupt("return", _context4.t1);

              case 26:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function makeLikeRequest(_x4) {
        return _makeLikeRequest.apply(this, arguments);
      }

      return makeLikeRequest;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props5 = this.props,
          contentType = _this$props5.contentType,
          showBestAnswer = _this$props5.showBestAnswer,
          showLike = _this$props5.showLike,
          topicId = _this$props5.topicId,
          isSubscribed = _this$props5.isSubscribed,
          privateReplyId = _this$props5.privateReplyId,
          topicTitle = _this$props5.topicTitle,
          privateId = _this$props5.privateId,
          isBestAnswer = _this$props5.isBestAnswer,
          topLikedBy = _this$props5.topLikedBy,
          showEditor = _this$props5.showEditor,
          likedBy = _this$props5.likedBy;
      var _this$state = this.state,
          showReportContentModal = _this$state.showReportContentModal,
          isLiked = _this$state.isLiked,
          isShareMenuOpen = _this$state.isShareMenuOpen,
          alert = _this$state.alert,
          showMarkAsSpamModal = _this$state.showMarkAsSpamModal,
          showTrashModal = _this$state.showTrashModal;
      var showLikedByInThreadedReplies = _common.common.isModuleActive('threadedRepliesDestination') && showLike && (likedBy === null || likedBy === void 0 ? void 0 : likedBy.length) > 0;
      return (0, _preact.h)(_globals.ModulesContext.Consumer, null, function (modules) {
        return (0, _preact.h)(_UserContext.CurrentUserContext.Consumer, null, function (user) {
          return (0, _preact.h)("ul", {
            className: (0, _classnames.default)('list', 'clearfix', 'text--meta', 'post__actions', 'qa-post-actions')
          }, showBestAnswer ? (0, _preact.h)("li", {
            className: "post__action-item"
          }, (0, _preact.h)("a", {
            href: "#",
            onClick: _this2.handleBestAnswerClick,
            className: (0, _classnames.default)('icon', 'icon--b', 'link--quiet', 'post__action-link', 'js-mark-answer', {
              'icon--checkmark': !isBestAnswer,
              'icon--cross': isBestAnswer
            })
          }, (0, _preact.h)("span", {
            className: "post__action-link__text"
          }, isBestAnswer ? (0, _preact.h)(_phrase.default, {
            p: "unmark.answer"
          }) : (0, _preact.h)(_phrase.default, {
            p: "Best answer"
          })))) : null, showLike ? (0, _preact.h)("li", {
            className: "post__action-item"
          }, (0, _preact.h)("a", {
            className: (0, _classnames.default)('link', 'link--quiet', 'icon--b', 'icon--thumb-up', 'qa-like-link', 'post__action-link', isLiked ? 'is-active' : ''),
            href: "#",
            onClick: user.id ? _this2.onLikeClick : TopicActions.showLoginModal
          }, (0, _preact.h)("span", {
            className: "post__action-link__text"
          }, (0, _preact.h)(_phrase.default, {
            m: "Common",
            key: isLiked ? 'unlike' : 'like',
            p: isLiked ? 'unlike' : 'like'
          })))) : null, showLikedByInThreadedReplies && (0, _preact.h)("li", {
            className: "post__action-item"
          }, (0, _preact.h)(_TopLikedBy.default, {
            likedBy: likedBy,
            topLikedBy: topLikedBy
          })), (0, _preact.h)("li", {
            className: "post__action-item"
          }, (0, _preact.h)("a", {
            className: (0, _classnames.default)('link', 'link--quiet', 'icon--b', 'icon--quote', 'qa-icon-quote', 'post__action-link'),
            href: "#",
            onClick: user.id ? _this2.onQuoteClick : TopicActions.showLoginModal
          }, (0, _preact.h)("span", {
            className: "post__action-link__text"
          }, (0, _preact.h)(_phrase.default, {
            p: "Quote"
          })))), _common.common.isModuleActive('threadedRepliesDestination') && showEditor ? (0, _preact.h)("li", {
            className: "post__action-item"
          }, (0, _preact.h)("a", {
            className: (0, _classnames.default)('link', 'link--quiet', 'icon--b', 'icon--comment', 'qa-reply-link', 'post__action-link'),
            href: "#",
            onClick: user.id ? _this2.props.onEditorClick : TopicActions.showLoginModal
          }, (0, _preact.h)("span", {
            className: "post__action-link__text"
          }, (0, _preact.h)(_phrase.default, {
            p: "Reply"
          })))) : null, topicId ? (0, _preact.h)("li", {
            className: "post__action-item"
          }, (0, _preact.h)(_TopicFavorite.default, {
            id: topicId,
            isSubscribed: isSubscribed,
            isGuestUser: user.id == null
          })) : null, topicId && modules.includes('TopicSocialShare') ? (0, _preact.h)("li", {
            className: "post__action-item"
          }, (0, _preact.h)("div", {
            className: "tooltip--share"
          }, (0, _preact.h)("div", {
            className: "tooltip tooltip--day",
            onMouseLeave: _this2.onShareLeave,
            onMouseEnter: _this2.onShareEnter
          }, (0, _preact.h)("span", {
            "data-qa": "share-button",
            className: (0, _classnames.default)('link', 'link--quiet', 'icon--b', 'icon--share', 'tooltip-trigger', 'post__action-link')
          }, (0, _preact.h)("span", {
            className: "post__action-link__text"
          }, (0, _preact.h)(_phrase.default, {
            p: "Share"
          }))), isShareMenuOpen ? (0, _preact.h)("div", {
            className: (0, _classnames.default)('tooltip__content', 'js-tooltip-content', 'position--bottom', 'is-enabled is-active')
          }, (0, _preact.h)("i", {
            className: "arrow",
            style: {
              left: '50%'
            }
          }), (0, _preact.h)(_phrase.default, {
            p: "twitter.share.title",
            renderAsText: true
          }, function (twitterPhrase) {
            return (0, _preact.h)("a", {
              title: twitterPhrase,
              className: (0, _classnames.default)('btn', 'btn--icon', 'btn--x', 'qa-button-twitter'),
              href: (0, _absoluteUrlRuntime.resolveUrl)("http://twitter.com/intent/tweet?text=https://".concat(window.location.hostname + window.location.pathname)),
              target: "_blank",
              rel: "noreferrer noopener"
            }, (0, _preact.h)(_phrase.default, {
              p: "twitter.share"
            }));
          }), (0, _preact.h)(_phrase.default, {
            p: "facebook.share.title",
            renderAsText: true
          }, function (facebookPhrase) {
            return (0, _preact.h)("a", {
              title: facebookPhrase,
              className: (0, _classnames.default)('btn', 'btn--icon', 'btn--facebook', 'qa-button-facebook'),
              href: (0, _absoluteUrlRuntime.resolveUrl)("https://www.facebook.com/sharer/sharer.php?u=".concat(encodeURIComponent('https://' + window.location.hostname + window.location.pathname))),
              target: "_blank",
              rel: "noreferrer noopener"
            }, (0, _preact.h)(_phrase.default, {
              p: "facebook.share"
            }));
          }), (0, _preact.h)(_phrase.default, {
            p: "linkedin.share.title",
            renderAsText: true
          }, function (linkedinPhrase) {
            return (0, _preact.h)("a", {
              title: linkedinPhrase,
              className: (0, _classnames.default)('btn', 'btn--icon', 'btn--linkedin', 'qa-button-linkedin'),
              href: (0, _absoluteUrlRuntime.resolveUrl)("https://www.linkedin.com/shareArticle?mini=true&url=https://".concat(window.location.hostname + window.location.pathname)),
              target: "_blank",
              rel: "noreferrer noopener"
            }, (0, _preact.h)(_phrase.default, {
              p: "linkedin.share"
            }));
          }), (0, _preact.h)(_phrase.default, {
            p: "whatsapp.share.title",
            renderAsText: true
          }, function (whatsappPhrase) {
            return (0, _preact.h)("a", {
              title: whatsappPhrase,
              className: (0, _classnames.default)('btn btn--icon btn--whatsapp icon icon--whatsapp is-hidden-mobile-up'),
              href: (0, _absoluteUrlRuntime.resolveUrl)("https://api.whatsapp.com/send?text=".concat(encodeURIComponent('https://' + window.location.hostname + window.location.pathname))),
              target: "_blank",
              rel: "noreferrer noopener"
            }, (0, _preact.h)(_phrase.default, {
              p: "whatsapp.share"
            }));
          })) : null))) : null, user.id ? _this2.getMenuOptions() : null, showReportContentModal && (0, _preact.h)(_ReportContentModal.default, {
            topicTitle: topicTitle,
            topicId: privateId,
            replyId: privateReplyId,
            contentType: contentType,
            showReportContentModal: _this2.showReportContentModal,
            userId: user.id,
            onShowAlert: _this2.handleShowAlert
          }), showMarkAsSpamModal && (0, _preact.h)(_MarkAsSpamModal.default, {
            title: privateReplyId ? 'frontend_moderation.mark_reply_as_spam' : 'frontend_moderation.mark_topic_as_spam',
            subTitle: privateReplyId ? 'frontend_moderation.spam_reply_warning' : 'frontend_moderation.spam_topic_warning',
            isOpen: showMarkAsSpamModal,
            onClose: function onClose() {
              return _this2.showMarkAsSpamModal(false);
            },
            onMarkAsSpam: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
              return _regenerator.default.wrap(function _callee5$(_context5) {
                while (1) {
                  switch (_context5.prev = _context5.next) {
                    case 0:
                      _context5.prev = 0;

                      if (!privateReplyId) {
                        _context5.next = 6;
                        break;
                      }

                      _context5.next = 4;
                      return (0, _topicService.markReplyAsSpam)((0, _contentType.getConsistentContentType)(contentType), privateReplyId);

                    case 4:
                      _context5.next = 9;
                      break;

                    case 6:
                      if (!privateId) {
                        _context5.next = 9;
                        break;
                      }

                      _context5.next = 9;
                      return (0, _topicService.markTopicAsSpam)((0, _contentType.getConsistentContentType)(contentType), privateId);

                    case 9:
                      _this2.handleShowAlert('success', privateReplyId ? (0, _preact.h)(_phrase.default, {
                        p: "frontend_moderation.reply_marked_as_spam"
                      }) : (0, _preact.h)(_phrase.default, {
                        p: "frontend_moderation.topic_marked_as_spam"
                      }));

                      _this2.showMarkAsSpamModal(false);

                      privateReplyId ? window.location.reload() : window.history.back();
                      _context5.next = 18;
                      break;

                    case 14:
                      _context5.prev = 14;
                      _context5.t0 = _context5["catch"](0);

                      _logger.logger.error(_context5.t0, {
                        component: 'TopicActions',
                        action: 'markAsSpam'
                      });

                      _this2.handleShowAlert('error', privateReplyId ? 'frontend_moderation.error_while_marking_reply_as_spam' : 'frontend_moderation.error_while_marking_topic_as_spam');

                    case 18:
                    case "end":
                      return _context5.stop();
                  }
                }
              }, _callee5, null, [[0, 14]]);
            }))
          }), showTrashModal && (0, _preact.h)(_TrashModal.default, {
            title: privateReplyId ? 'frontend_moderation.trash_the_reply' : 'frontend_moderation.trash_the_topic',
            subTitle: privateReplyId ? 'frontend_moderation.trash_reply_warning' : 'frontend_moderation.trash_topic_warning',
            isOpen: showTrashModal,
            onClose: function onClose() {
              return _this2.showTrashModal(false);
            },
            onTrash: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6() {
              var isReply, id;
              return _regenerator.default.wrap(function _callee6$(_context6) {
                while (1) {
                  switch (_context6.prev = _context6.next) {
                    case 0:
                      _context6.prev = 0;
                      isReply = !!privateReplyId;
                      id = isReply ? privateReplyId : privateId;

                      if (!id) {
                        _context6.next = 6;
                        break;
                      }

                      _context6.next = 6;
                      return isReply ? (0, _topicService2.toggleReplyTrashed)((0, _contentType.getConsistentContentType)(contentType), id, true) : (0, _topicService2.toggleTrashed)((0, _contentType.getConsistentContentType)(contentType), id, true);

                    case 6:
                      isReply ? window.location.reload() : window.history.back();

                      _this2.handleShowAlert('success', isReply ? (0, _preact.h)(_phrase.default, {
                        p: "frontend_moderation.reply_trashed"
                      }) : (0, _preact.h)(_phrase.default, {
                        p: "frontend_moderation.topic_trashed"
                      }));

                      _this2.showTrashModal(false);

                      _context6.next = 15;
                      break;

                    case 11:
                      _context6.prev = 11;
                      _context6.t0 = _context6["catch"](0);

                      _logger.logger.error(_context6.t0, {
                        component: 'TopicActions',
                        action: 'toggleTrashed'
                      });

                      _this2.handleShowAlert('error', privateReplyId ? 'frontend_moderation.error_while_trashing_reply' : 'frontend_moderation.error_while_trashing_topic');

                    case 15:
                    case "end":
                      return _context6.stop();
                  }
                }
              }, _callee6, null, [[0, 11]]);
            }))
          }), (alert === null || alert === void 0 ? void 0 : alert.message) && (0, _preact.h)(_AlertComponent.default, {
            sticky: true,
            messageType: alert.type,
            isVisibleFor: 3000,
            onTimeoutEnd: function onTimeoutEnd() {
              return _this2.setState({
                alert: undefined
              });
            }
          }, alert.message));
        });
      });
    }
  }], [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8() {
        var phrases;
        return _regenerator.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                phrases = [{
                  module: 'Forum',
                  key: 'topic_view.reported_content_option.report'
                }, {
                  module: 'Forum',
                  key: 'topic_view.reported_content_modal.report_content'
                }, {
                  module: 'Forum',
                  key: 'topic_view.reported_content_modal.topic'
                }, {
                  module: 'Forum',
                  key: 'topic_view.reported_content_modal.note'
                }, {
                  module: 'Forum',
                  key: 'topic_view.reported_content_modal.reason'
                }, {
                  module: 'Forum',
                  key: 'topic_view.reported_content_modal.reason.placeholder'
                }, {
                  module: 'Forum',
                  key: 'topic_view.reported_content_modal.reason_not_provided.error'
                }, {
                  module: 'Forum',
                  key: 'topic_view.reported_content_modal.error'
                }, {
                  module: 'Forum',
                  key: 'topic_view.reported_content_modal.cancel'
                }, {
                  module: 'Forum',
                  key: 'topic_view.reported_content.success'
                }];
                _context8.next = 3;
                return Promise.all(phrases.map( /*#__PURE__*/function () {
                  var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(p) {
                    return _regenerator.default.wrap(function _callee7$(_context7) {
                      while (1) {
                        switch (_context7.prev = _context7.next) {
                          case 0:
                            _context7.next = 2;
                            return new Promise(function (resolve) {
                              return (0, _phrase.fetchPhrase)(p.module, p.key, function (phrase) {
                                return resolve(phrase);
                              });
                            });

                          case 2:
                            return _context7.abrupt("return", _context7.sent);

                          case 3:
                          case "end":
                            return _context7.stop();
                        }
                      }
                    }, _callee7);
                  }));

                  return function (_x5) {
                    return _ref6.apply(this, arguments);
                  };
                }()));

              case 3:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }]);
  return TopicActions;
}(_preact.Component);

(0, _defineProperty2.default)(TopicActions, "showLoginModal", function (e) {
  e.preventDefault();
  window.dispatchEvent(new CustomEvent('GuestUserAction'));
});

var _default = (0, _OnDemandTranslations.withOnDemandTranslationProps)(TopicActions, ['onDisplayOriginal', 'isPostTranslated']);

exports.default = _default;